import { integrations } from '../apis.js';
const req = integrations('', true);
export const getAll = () => req('GET', `/`);
export const get = (id) => req('GET', `/${id}`);
export const activate = (id, activation) => req('POST', `/${id}/activations`, {
    body: activation,
});
export const deactivate = (id) => req('POST', `/activations/${id}/deactivate`);
export const reactivate = (id) => req('POST', `/activations/${id}/reactivate`);
export const getCreditorActivations = (creditorId) => req('GET', `/creditors/${creditorId}/activations`);
export const getActivation = (id) => req('GET', `/activations/${id}`);
export const getMissingApplications = (creditorId, options) => req('GET', `/entry-applications/missing?${new URLSearchParams({
    creditorId,
    ...options,
})}
    `);
export const getMissingApplicationCounts = () => req('GET', '/entry-applications/missing-counts');
export const createApplications = (applications) => req('POST', '/entry-applications', {
    body: applications,
});
//# sourceMappingURL=integrations.js.map